export const BLOG_PAGE_SIZE = 6;
export const blogPagePath = page => page === 1 ? '/blog' : `/blog/page/${page}`;
export const blogPageMetadata = page => ({
  title: `${page === 1 ? '' : `Page ${page} | `}AI Agents, RAG & Data Engineering Blog | DataBackfill`,
  description: 'Practical write-ups on shipping AI agents, RAG systems, and data infrastructure into production from the DataBackfill team.',
  path: blogPagePath(page),
});
export const blogPostMetadata = (post, slug) => ({
  title: post ? `${post.title} | DataBackfill` : 'Post not found | DataBackfill',
  description: post ? post.excerpt : 'This article could not be found. Browse the DataBackfill blog.',
  path: `/blog/${encodeURIComponent(slug)}`,
  image: post?.image,
  article: Boolean(post),
  noindex: !post,
});
